<template>
    <div :class="{'mv_prod': root}" v-if="category">
        <div v-if="!first" class="mv_prod_row mv_category_head" @click="expandAll ? null : expand(category.id)"><b>{{category.name}}</b><div style="text-align:right"><font-awesome-icon v-if="!expandAll && (products.length > 0 || category.children.length > 0)"  icon="chevron-down" :class="{upside: expandAll || exp == category.id}" /></div></div>
        <div ref="exp" v-if="products.length > 0 || category.children.length > 0">
        <div v-if="expandAll || expanded || exp == category.id" :class="{'mv_subprod_list': !first}">
            <Product class="product" v-for="p in products" :key="p.id" :product="p">{{p}}</Product>
            <CategoryCatalog :expandAll="expandAll"  v-for="c in category.children"  :key="c.id" :category="c" />
        </div>
        </div>
    </div>
</template>

<script>
import Product from '../components/Product'
import smoothReflow from 'vue-smooth-reflow'
export default {
    props: ['category', 'root', 'first', 'expanded', 'expandAll'],
    data () {
        return {
            exp: null
        }
    },
       mounted () {
        this.$smoothReflow({
        el: this.$refs.exp,
        transition: '.3s cubic-bezier(.19,1,.22,1)'
        })
        console.log(this.product)
    },
    mixins: [
        smoothReflow
    ],
    components: {
        Product
    },
    name: "CategoryCatalog",
    methods: {
        expand(id){
            this.exp = (this.exp === id ? null : id)
        }
    }, 
    computed: {
        products(){
            return this.$store.state.products.filter(x => x.categories.map(k => k.id).indexOf(this.category.id) !== -1)
        }
    }
}
</script>
<style lang="scss">


      

        .mv_prod_row {
            -webkit-user-select: none;
            user-select: none;
            display: grid;
            grid-template-columns: 1fr;
            // cursor: pointer;
            justify-content: space-between;
            align-items: center;
            border-bottom:  1px solid #DDD;
            line-height: 28px;
            box-sizing:border-box;padding: .5em 1em;
            @media screen and (max-width: 768px) {
                &.mv_category_head {
                   
                    position: sticky;
                    top: 0;
                    background-color: white;
                }
            }
            &.mv_category_head {
                 grid-template-columns: 4fr 1fr;
            }
            .svg-inline--fa {
                transition: .2s;
                &.upside {
                    transform: rotate(-180deg);
                }
            }
        }
  
        .mv_subprod_list {
            padding-top: 1em;
            padding-bottom:1em;
            padding-left: 2em;
            background-color: #EEE;

            @media screen and (max-width:768px) {
                padding-left: 0;
            }
            
          
     
        }

        .mv_subprod_list > div:last-child .mv_prod_row, .mv_subprod_list > .mv_prod_row:last-child  {
            border-bottom: none;
        }
</style>